<template>
    <div v-if="relatedData?.data && relatedData.data.length > 0">
        <div class="card-body shadow rounded">
            <p class="d-inline-flex gap-1 m-2">
                <a data-bs-toggle="collapse" href="#relatedTableTab" role="button" aria-expanded="true" aria-controls="relatedTableTab" @click="this.collapsed = !this.collapsed">
                    <svg class="icon icon-primary fixed-icon">
                    <use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#" + (this.collapsed ? "it-expand" : "it-collapse")'></use>
                    </svg>
                    Potrebbe interessarti...
                </a>
            </p>
            <hr class="my-0">
            <div v-if="relatedData?.data && relatedData.data.length > 0" class="container-fluid p-0 m-0 show" id="relatedTableTab">
                <div class="row m-0 p-0">
                    <div id="related-table" class="mt-2 p-3">
						<div class="mb-3">
							<div class="d-flex flex-wrap gap-2">
								<button v-for="type in availableTypes" :key="type.name" type="button" 
									class="btn btn-xs rounded-pill p-2" 
									:class="filteredTag === type.name ? 'btn-primary text-white' : 'btn-outline-secondary'" 
									@click="setTypeFilter(type.name)">
									<small>{{ type.mappedName ?? "N/A" }}</small>
									<span class="badge rounded-pill bg-white ms-1 p-1" :class="filteredTag === type.name ? 'text-primary' : 'text-secondary'">{{ type.count }}</span>
								</button>
							</div>
						</div>

                        <!-- Table with related content -->
                        <div class="table-responsive shadow-sm rounded">
                            <table class="table table-hover table-striped table-borderless mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col" class="text-center" style="width: 15%">Tipologia</th>
                                        <th scope="col">Contenuto</th>
                                        <th scope="col" class="text-center" style="width: 15%">Azioni</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="filteredRelated.length === 0">
                                        <td colspan="3" class="text-center py-4">
                                            <em class="text-muted">Nessun contenuto correlato trovato</em>
                                        </td>
                                    </tr>
                                    <tr v-for="item in paginatedRelated" :key="item.id">
                                        <td class="align-middle text-center">
                                            <span class="badge rounded-pill pb-2 bg-primary">{{ mappedType[item.type] ?? "N/A" }}</span>
                                        </td>
                                        <td class="align-middle">
                                            <h6 class="mb-1" v-if="item.title">{{ item.title }}</h6>
                                            <p class="text-secondary mb-0 small">{{ item.summary }}</p>
                                        </td>
                                        <td class="align-middle text-center">
                                            <a :href="item.url" class="btn btn-outline-primary btn-sm btn-icon">
                                                <svg class="icon icon-xs icon-primary me-2">
                                                    <use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-external-link"'></use>
                                                </svg>
                                                <span>Visualizza</span>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Pagination -->
                        <nav class="mt-4" v-if="relatedData.pagination && relatedData.pagination.total_pages > 1">
                            <ul class="pagination justify-content-center">
                                <!-- Previous button -->
                                <li class="page-item" :class="{ disabled: relatedData.pagination.current_page === 1 }">
                                    <a class="page-link" href="#" @click.prevent="goToPage(relatedData.pagination.current_page - 1)">
                                        <svg class="icon icon-sm">
                                            <use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-chevron-left"'></use>
										</svg>
									</a>
								</li>
								<!-- Page numbers -->
								<li v-for="page in getVisiblePages()" :key="page" class="page-item" 
									:class="{ active: page === relatedData.pagination.current_page, 'disabled': page === '...' }">
									<a class="page-link" href="#" @click.prevent="goToPage(page)">{{ page }}</a>
								</li>
								<!-- Next button -->
								<li class="page-item" :class="{ disabled: relatedData.pagination.current_page === relatedData.pagination.total_pages }">
									<a class="page-link" href="#" @click.prevent="goToPage(relatedData.pagination.current_page + 1)">
										<svg class="icon icon-sm">
											<use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-chevron-right"'></use>
										</svg>
									</a>
								</li>
							</ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: 'RelatedTable',
	props: {
		related: {
			type: Object,
			default: () => ({
				data: [],
				pagination: {
					current_page: 1,
					total_pages: 1,
					total: 0
				},
				filteredTag : ''
			})
		}
	},
	data() {
		return {
			searchQuery: '',
			typeFilter: '',
			currentPage: 1,
			itemsPerPage: 5,
			dateFormatter: new Intl.DateTimeFormat('it-IT', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			}),
            collapsed: false,
			localRelated: null,
			mappedType: {
				"Tutti" : "Tutti",
				"podcast": "Podcast",
				"webinar": "Webinar",
				"faq_anac": "FAQ ANAC"
			}
		}
	},
	computed: {
		relatedData() {
			// Use localRelated if available, otherwise use the prop
			return this.localRelated || this.related;
		},
		availableTypes() {
			if (!this.relatedData?.data) return [];
			let all = 0;
			let types =  Object.keys(this.relatedData.facets.type).map((type) => {
				all += this.relatedData.facets.type[type];
				return {
					name: type,
					mappedName: this.mappedType[type],
					count: this.relatedData.facets.type[type]
				}
			});
			types.push({
				name: 'Tutti',
				mappedName: this.mappedType["Tutti"],
				count: all
			});
			return types;
		},
		filteredRelated() {
			if (!this.relatedData?.data) return [];
			
			// Start with type filtering
			let filtered = this.relatedData.data;
			if (this.typeFilter) {
				filtered = filtered.filter(item => 
					item.type === this.typeFilter
				);
			}
			
			// Then apply search query filtering
			if (this.searchQuery) {
				const query = this.searchQuery.toLowerCase();
				filtered = filtered.filter(item => {
					return (
						(item.type && item.type.toLowerCase().includes(query)) ||
						(item.summary && item.summary.toLowerCase().includes(query)) ||
						(item.title && item.title.toLowerCase().includes(query))
					);
				});
			}
			
			return filtered;
		},
		totalItems() {
			return this.filteredRelated.length;
		},
		totalPages() {
			return Math.ceil(this.totalItems / this.itemsPerPage);
		},
		paginatedRelated() {
			const startIndex = (this.currentPage - 1) * this.itemsPerPage;
			const endIndex = startIndex + this.itemsPerPage;
			return this.filteredRelated.slice(startIndex, endIndex);
		},
		displayedPages() {
			const pages = [];
			const maxVisiblePages = 5;
			
			if (this.totalPages <= maxVisiblePages) {
				// Show all pages if there are fewer than maxVisiblePages
				for (let i = 1; i <= this.totalPages; i++) {
					pages.push(i);
				}
			} else {
				// Always show first page
				pages.push(1);
				
				// Calculate middle pages
				let startPage = Math.max(2, this.currentPage - 1);
				let endPage = Math.min(this.totalPages - 1, startPage + 2);
				
				// Adjust if we're near the end
				if (endPage === this.totalPages - 1) {
					startPage = Math.max(2, endPage - 2);
				}
				
				// Add ellipsis if needed
				if (startPage > 2) {
					pages.push('...');
				}
				
				// Add middle pages
				for (let i = startPage; i <= endPage; i++) {
					pages.push(i);
				}
				
				// Add ellipsis if needed
				if (endPage < this.totalPages - 1) {
					pages.push('...');
				}
				
				// Always show last page
				pages.push(this.totalPages);
			}
			
			return pages;
		}
	},
	created() {
		// Initialize localRelated from the related prop when component is created
		if (this.related) {
			this.localRelated = JSON.parse(JSON.stringify(this.related));
		}
	},
	watch: {
		// Watch for changes to the related prop and update localRelated
		related: {
			deep: true,
			handler(newValue) {
				if (newValue) {
					this.localRelated = JSON.parse(JSON.stringify(newValue));
				}
			}
		}
	},
	methods: {
		getVisiblePages() {
			const currentPage = this.relatedData.pagination.current_page;
			const totalPages = this.relatedData.pagination.total_pages;
			const delta = 1; // Numero di pagine da mostrare prima e dopo la pagina corrente
			
			if (totalPages <= 5) {
				// Se ci sono 5 o meno pagine, mostra tutte
				return Array.from({length: totalPages}, (_, i) => i + 1);
			}
			
			let pages = [];
			
			// Sempre mostra la prima pagina
			pages.push(1);
			
			// Calcola l'intervallo intorno alla pagina corrente
			const leftBound = Math.max(2, currentPage - delta);
			const rightBound = Math.min(totalPages - 1, currentPage + delta);
			
			// Aggiungi ellissi a sinistra se necessario
			if (leftBound > 2) {
				pages.push('...');
			} else if (leftBound === 2) {
				pages.push(2);
			}
			
			// Aggiungi le pagine centrali
			for (let i = Math.max(leftBound, 3); i <= Math.min(rightBound, totalPages - 2); i++) {
				pages.push(i);
			}
			
			// Aggiungi ellissi a destra se necessario
			if (rightBound < totalPages - 1) {
				pages.push('...');
			} else if (rightBound === totalPages - 1) {
				pages.push(totalPages - 1);
			}
			
			// Sempre mostra l'ultima pagina
			pages.push(totalPages);
			
			return pages;
		},
		setTypeFilter(type) {
			this.filteredTag = type;
			this.resetPagination();
		},
		formatDate(dateString) {
			if (!dateString) return 'N/A';
			try {
				const date = new Date(dateString);
				return this.dateFormatter.format(date);
			} catch (e) {
				return 'N/A';
			}
		},
		getItemType(item) {
			// Determine the type of the related item
			if (item.type) return item.type;
			if (item.node_type) return item.node_type;
			return 'Articolo';
		},
		getItemUrl(item) {
			// Generate URL based on item type
			const baseUrl = this.$root.baseURL;
			
			// Default to article view
			let url = `${baseUrl}?view=article&article=${item.id}`;
			
			// If the item has a specific version, include it
			if (item.version_id) {
				url += `&version=${item.version_id}`;
			}
			
			return url;
		},
		async goToPage(page) {
			if (page === "...") {
				return
			}
			if (!this.localRelated) {
				this.localRelated = JSON.parse(JSON.stringify(this.related));
			}

			if (this.relatedData?.pagination && this.relatedData.data && this.relatedData.data.length > 0) { // Check if we have backend pagination available
				let url = `${this.$root.config.VUE_APP_BACKOFFICE_URL}/load-related/${this.$route.query.article}/${this.$route.query.version}?page=${page}`; // Use backend pagination
				try {
					if (this.filteredTag) {
						url += `&tag=${this.filteredTag}`;
					}
					const response = await fetch(url);
					const data = await response.json();
					this.localRelated = data;
					this.$emit('related-updated', data); // Emit an event to inform parent component about the data change
				} catch (error) {
					console.error('Error loading related articles:', error);
				}
			}
		},
		resetPagination() {
			this.currentPage = 1;
			if (this.relatedData?.pagination) {
				this.goToPage(1);
			}
		}
	}
}
</script>

<style scoped>
/* Pagination styles */
.pagination .page-link {
	color: var(--bs-primary);
}

.pagination .page-item.active .page-link {
	background-color: var(--bs-primary);
	border-color: var(--bs-primary);
	color: white;
}

/* Collapse toggle icon */
.collapse-toggle {
    cursor: pointer;
    transition: transform 0.3s ease;
}
.collapse-toggle.collapsed {
    transform: rotate(-90deg);
}

/* Bootstrap Italia specific styles */
.btn-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.375rem 0.75rem;
}

.btn-icon .rounded-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.5rem;
}

/* Extra small button size */
.btn-xs {
    font-size: 0.7rem;
    line-height: 1.2;
}

.badge {
	font-size: 0.75rem;
}

.badge.rounded-pill {
    padding: 0.35em 0.65em;
    font-weight: 600;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
    background-color: rgba(0, 0, 0, 0.02);
}

/* Table cell styling */
.table td {
    vertical-align: middle;
}

.table td h6 {
    margin-bottom: 0.25rem;
    color: var(--bs-primary);
}

.table td p.text-secondary {
    margin-bottom: 0;
    font-size: 0.875rem;
}
</style>
